/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import React from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import SompoContentBox from "../../component/wrapper/SompoContentBox";
import Alert from "./homeContents/Alert";
import Status from "./homeContents/Status";
import Information from "./homeContents/Information";
import CourseTop from "./homeContents/course/CourseTop";
import Category from "../../component/category/Category";
import NewCourse from "./homeContents/NewCourse";
import { useScreenSize } from "../../component/Theme";
import { HomeProps } from "./Home";

const HomeSJ = (props: HomeProps) => {
    const { desktop } = useScreenSize();
    const { histories } = props;
    return (
        <>
            <Grid container item sx={{ width: "100%" }}>
                <Alert histories={histories} />
            </Grid>
            <Grid
                container
                direction={desktop ? "row" : "column"}
                justifyContent={desktop ? "space-between" : "center"}
                rowSpacing={desktop ? 0 : 4}
                sx={{ p: desktop ? 2 : 0, width: "100%", pt: "12px" }}
            >
                {desktop ? (
                    <>
                        <Grid item xs={8.8}>
                            <SompoContentBox>
                                <Status />
                                <CourseTop {...props} />
                            </SompoContentBox>
                            <Box sx={{ width: "95%", margin: "0 auto", mt: 8 }}>
                                <Category />
                                <NewCourse {...props} />
                            </Box>
                        </Grid>
                        <Grid item xs={2.8}>
                            <Information />
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid item sx={{ width: "100%" }}>
                            <SompoContentBox>
                                <Status />
                            </SompoContentBox>
                        </Grid>
                        <Grid item sx={{ width: "100%" }}>
                            <Paper elevation={0} sx={{ ml: -2, width: "100vw", px: 2, pb: 3 }}>
                                <CourseTop {...props} />
                            </Paper>
                        </Grid>
                        <Grid item sx={{ width: "100%" }}>
                            <Information />
                        </Grid>
                        <Grid item sx={{ width: "100%" }}>
                            <NewCourse {...props} />
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    );
};

export default HomeSJ;
